import React from 'react'
import PropTypes from 'prop-types'
import Lottie from 'react-lottie'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'

import Header from 'core/templates/header'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import TitleIcon from 'core/layouts/title-icon'

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: ${props =>
    props.campaign &&
    props.campaign.theme &&
    props.campaign.theme.header &&
    props.campaign.theme.header.header &&
    props.campaign.theme.header.header.height
      ? `${props.campaign.theme.header.header.height}px`
      : '64px'};
  padding-right: ${props => (props.isMobile ? '15px' : 'inherit')};
  padding-left: ${props => (props.isMobile ? '15px' : 'inherit')};
  text-align: ${props => (props.isMobile ? 'center' : 'inherit')};
`
const Wrapper = styled.div`
  display: ${props => (props.hidden ? 'none' : 'inherit')};
`

const TradeInContext = ({ children, loading, campaign, animationOption }) => (
  <>
    {loading && (
      <>
        <Header />
        <Container campaign={campaign} isMobile={isMobile}>
          <MainContentWrapper
            cssId="globaldealer-subtitle-trade-in-context"
            title="Veuillez patienter"
          />
          <TitleIcon
            cssId="globaldealer-subtitle-trade-in-context"
            title="Nous vous redirigeons sur le parcours de votre distributeur."
          />
          {animationOption && (
            <Lottie
              options={animationOption}
              isClickToPauseDisabled
              width={isMobile ? '250px' : '400px'}
              height="auto"
            />
          )}
        </Container>
      </>
    )}
    <Wrapper hidden={loading}>{children}</Wrapper>
  </>
)

TradeInContext.propTypes = {
  // intl: PropTypes.shape().isRequired,
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool.isRequired,
  campaign: PropTypes.shape().isRequired,
  animationOption: PropTypes.shape()
}

export default TradeInContext
